import React from "react";
import PropTypes from 'prop-types';

const Tick = props => (
  <svg width={props.width} height={props.height} viewBox="0 0 8 6" className={props.className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
      <g transform="translate(-1106.000000, -433.000000)" stroke={props.stroke} strokeWidth="2">
        <g transform="translate(1102.000000, 427.000000)">
          <g transform="translate(4.500000, 6.000000)">
            <path d="M0.5,2.5 L2.26776695,4.26776695"></path>
            <path d="M2.5,4.5 L6.03553391,0.964466094"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Tick.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  stroke: PropTypes.string
}

Tick.defaultProps = {
  width: 8,
  height: 6,
  className: "",
  stroke: "#FFFFFF"
}

export default Tick;



// WEBPACK FOOTER //
// ./src/components/svgs/Tick.js